import React, { useEffect  } from 'react';
import './Home.css';
import Navbar from '../H&F/Navbar';
import Footer from '../H&F/Footer';
import HOMEHERO from '../images/HOMEHERO.webp';
import WASHMAN1 from '../images/WASHMAN1.webp';
import ACSERVICE1 from '../images/ACSERVICEGAL.webp';
import REFMAN1 from '../images/REFMAN1.webp';
import MICROMAN1 from '../images/MICROMAN1.webp';
import TVMAN1 from '../images/TVMAN1.webp';
import WATMAN1 from '../images/WATMAN1.webp';
import WATERP1 from '../images/WATERP1.webp';
import Discliamber from './Discliamer'
export default function HOME() {

  useEffect(() => {
    window.scrollTo(0, 0);  
  }, []);


const handleSubmit = async (e) => {
  e.preventDefault();
  const form = e.target;

  const formData = {
    name: form.name.value,
    phone: form.phone.value,
    location: form.location.value,
    issue: `  ${form.issue.value}
    
    - this calls coming from madurai 2.0 Nagaraj Account (HomeApplianceServiceMadurai.in)
    `,
    toMail: "expresshelplinecare@gmail.com",
  };

  // ✅ validate phone number before sending
  const phoneRegex = /^[0-9]{10}$/;
  if (!phoneRegex.test(formData.phone)) {
    alert("Please enter a valid 10-digit mobile number (numbers only).");
    return;
  }

  const spinner = document.getElementById("spinnerOverlay");
  if (spinner) spinner.style.display = "flex";

  try {
    const res = await fetch("https://form.e2ecrm.in/api/sendmail", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(formData),
    });

    if (!res.ok) throw new Error(`Server responded with ${res.status}`);

    let data;
    try {
      data = await res.json();
    } catch {
      throw new Error("Invalid JSON response from server");
    }

    alert("Thank you! Your service request is confirmed. Our engineer will call you shortly.");
    form.reset();
  } catch (err) {
    console.error("Form submit error:", err);
    alert(`Error sending complaint: ${err.message}`);
  } finally {
    if (spinner) spinner.style.display = "none";
  }
};




// const handleSubmit = async (e) => {
//   e.preventDefault();
//   const form = e.target;

//   const formData = {
//     name: form.name.value,
//     phone: form.phone.value,
//     location: form.location.value,
//     issue: `  ${form.issue.value}
    
//     - this calls coming from madurai 2.0 Nagaraj Account (HomeApplianceServiceMadurai.in)
//     `,  
//     toMail: "expresshelplinecare@gmail.com",
//   };

//   const spinner = document.getElementById("spinnerOverlay");
//   if (spinner) spinner.style.display = "flex";

//   try {
//     const res = await fetch(
//       "https://form.e2ecrm.in/api/sendmail",
//       {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(formData),
//       }
//     );

//     if (!res.ok) {
//       throw new Error(`Server responded with ${res.status}`);
//     }

//     let data;
//     try {
//       data = await res.json();
//     } catch {
//       throw new Error("Invalid JSON response from server");
//     }

//    alert("Thank you! Your service request is confirmed. Our engineer will call you shortly.");
//     form.reset();
//   } catch (err) {
//     console.error("Form submit error:", err);
//     alert(`Error sending complaint: ${err.message}`);
//   } finally {
//     if (spinner) spinner.style.display = "none";
//   }
// };
 
  
  
  return (
    <>
      <div><Navbar /></div>

     
        {/* <section id="hero" style={{ backgroundImage: `url(${HOMEHERO})`}}>
          <div className="hero-content">
            <h1>HOME APPLIANCE REPAIR SERVICE</h1>
            <p>Reliable solutions for all your home appliances!</p>
            <a href="tel:+918610867933" className="hero-btn">+91 86108 67933</a>
          </div>
        </section> */}


<section
  id="hero-section"
  style={{ backgroundImage: `url(${HOMEHERO})` }}
>
  <div className="overlay">
    <div className="content">
      {/* Left Content */}
      <div className="text-content">
       <h1>All-in-One Home Appliance Service</h1>
<p>Repair, maintenance, and installation for all major home appliances. Fast, professional, and cost-effective service at your doorstep.</p>
<a href="tel:+918610867933" className="hero-btn">
          +91 86108 67933
        </a>
      </div>

      {/* Right Form */}
      <div className="form-container">
        <form id="bookingForm" onSubmit={handleSubmit}>
          <input
            type="text"
            name="name"
            placeholder="Enter Your Full Name"
            required
          />
       <input
  type="text"
  name="phone"
  id="phone"
  placeholder="Enter 10-digit mobile number"
  maxlength="10"
  required
  oninput="this.value = this.value.replace(/[^0-9]/g, '')"
/>

          <input
            type="text"
            name="location"
            placeholder="Enter Your Address"
            required
          />
          <textarea
            name="issue"
            placeholder="Describe Your Appliance Problem"
            required
          ></textarea>
    <p
  style={{
    marginTop: "12px",
    fontSize: "14px",
    color: "#ffffff",
    fontWeight: "700",
    textAlign: "center",
  }}
>
  Your information is kept secure and used only for your service request.
</p>
          <button type="submit">Book Complaint</button>
        </form>
      </div>
    </div>

    {/* Dot Loader */}
    <div id="spinnerOverlay" className="spinner-overlay">
      <div className="dot-loader">
        <span></span>
        <span></span>
        <span></span>
      </div>
      <p className="loading-text">Booking your complaint</p>
    </div>
  </div>
</section>






        <section id="about">
  <div class="container">
    <div class="row">
      <div class="col-lg-12 col-md-12 col-sm-12 col-12">
        <h2>About Us</h2>
        <p class="about-description">
          We are a trusted home appliance service company with over 6 years of experience providing exceptional service and 100% customer satisfaction. Our experts are skilled in servicing a wide range of home appliances, ensuring that your household operates smoothly.
        </p>

        <div class="services">
          <div class="service-item">
            <img src={WASHMAN1} alt='washing machine service' title='washing machine serrvice' className='img-fluid'/>
            <h3 class="service-title">Washing Machine Service</h3>
          </div>
          <div class="service-item">
          <img src={ACSERVICE1} alt='washing machine service' title='washing machine serrvice' className='img-fluid'/>
            <h3 class="service-title" id="UPDOWN">AC Service</h3>
          </div>
          <div class="service-item">
          <img src={TVMAN1} alt='washing machine service' title='washing machine serrvice' className='img-fluid'/>
            <h3 class="service-title" id="UPDOWN">TV Service</h3>
          </div>
          <div class="service-item">
          <img src={MICROMAN1} alt='washing machine service' title='washing machine serrvice' className='img-fluid'/>
            <h3 class="service-title">Microwave Oven Service</h3>
          </div>
          <div class="service-item">
          <img src={REFMAN1} alt='washing machine service' title='washing machine serrvice' className='img-fluid'/>
            <h3 class="service-title">Fridge Service</h3>
          </div>
          <div class="service-item">
          <img src={WATMAN1} alt='washing machine service' title='washing machine serrvice' className='img-fluid'/>
            <h3 class="service-title">Water Heater Service</h3>
          </div>
          <div class="service-item">
          <img src={WATERP1} alt='washing machine service' title='washing machine serrvice' className='img-fluid'/>
            <h3 class="service-title">Water Purifier Service</h3>
          </div>
        </div>

        <p class="about-footer">
          With over 6+ years of experience and a 100% customer satisfaction guarantee, we ensure your appliances are in good hands.
        </p>
      </div>
    </div>
  </div>
</section>









<section id="how-we-work">
  <h2>How We Work</h2>
  <div class="work-cards">
    <div class="work-card">
      <i class="fas fa-bullhorn"></i>
      <h3>Promotion</h3>
      <p>We promote our website using Google Ads to get daily regular customers.</p>
    </div>
    <div class="work-card">
      <i class="fas fa-phone-alt"></i>
      <h3>Contact Us</h3>
      <p>Customers can reach us directly via the phone call option available on our website.</p>
    </div>
    <div class="work-card">
      <i class="fas fa-clipboard-list"></i>
      <h3>Complaint Registration</h3>
      <p>Our customer team registers the issue and forwards it to our technician.</p>
    </div>
    <div class="work-card">
      <i class="fas fa-calendar-check"></i>
      <h3>Technician Visit</h3>
      <p>Our technician gets an appointment and visits the customer's place to resolve the issue within 3-4 hours.</p>
    </div>
    <div class="work-card">
      <i class="fas fa-money-check-alt"></i>
      <h3>Service Charge</h3>
      <p>The basic service charge is ₹300 across Tamil Nadu. Spare parts charges are separate.</p>
    </div>
  </div>
</section>


<section id="gallery">
  <h2>Our Gallery</h2>
  <div class="gallery-grid">
    <div class="gallery-item large-item">
      <img src={WASHMAN1} alt="Image 1"/>
    </div>
    <div class="gallery-item medium-item" >
      <img src={ACSERVICE1} alt="Image 2"/>
    </div>
    <div class="gallery-item medium-item" >
      <img src={REFMAN1} alt="Image 3"/>
    </div>
    <div class="gallery-item large-item">
      <img src={MICROMAN1} alt="Image 4"/>
    </div>
    <div class="gallery-item medium-item" >
      <img src={TVMAN1} alt="Image 5"/>
    </div>
    <div class="gallery-item medium-item" >
      <img src={WATMAN1} alt="Image 6"/>
    </div>
    <div class="gallery-item large-item">
      <img src={WATERP1} alt="Image 7" />
    </div>
  </div>
</section>


<section id="tech-special">
  <h2>Our Key Benefits</h2>
  <div class="benefit-cards">
    <div class="benefit-card">
      <i class="fas fa-cogs"></i>
      <h3>Tech Specialist</h3>
      <p>Our team consists of highly skilled technicians who specialize in all home appliance repairs.</p>
    </div>
    <div class="benefit-card">
      <i class="fas fa-wrench"></i>
      <h3>Quick Fixer</h3>
      <p>We diagnose and fix issues quickly, minimizing any inconvenience to our customers.</p>
    </div>
    <div class="benefit-card">
      <i class="fas fa-truck-fast"></i>
      <h3>Fast Delivery</h3>
      <p>We offer quick response times and arrive promptly at your location to deliver our services.</p>
    </div>
    <div class="benefit-card">
      <i class="fas fa-users"></i>
      <h3>Customer Friendly</h3>
      <p>Our customer support team is available to assist you every step of the way with a friendly approach.</p>
    </div>
    <div class="benefit-card">
      <i class="fas fa-check-circle"></i>
      <h3>High Quality Work</h3>
      <p>We ensure that every service we offer meets the highest quality standards and customer satisfaction.</p>
    </div>
  </div>
</section>










<section id="our-services">
  <h2>Our Services</h2>
  <div class="container">
   
   
    <div class="row service-item-washing-machine">
      <div class="col-md-6">
        <img src={WASHMAN1} alt="Washing Machine Service" title="Washing Machine Service" class="img-fluid" />
      </div>
      <div class="col-md-6">
        <h3 id="service-heading-washing-machine">Washing Machine Service</h3>
        <p id="service-description-washing-machine">Choose our washing machine service and get a thorough and professional repair that guarantees excellent results and long-lasting performance.</p>
      </div>
    </div>

  
    <div class="row service-item-ac-service">
      <div class="col-md-6">
        <img src={ACSERVICE1} alt="AC Service" title="AC Service" class="img-fluid" />
      </div>
      <div class="col-md-6">
        <h3 id="service-heading-ac-service">AC Service</h3>
        <p id="service-description-ac-service">Our AC service ensures your air conditioning unit runs efficiently, keeping your home cool and comfortable while saving on energy costs.</p>
      </div>
    </div>

 
    <div class="row service-item-fridge-service">
      <div class="col-md-6">
        <img src={REFMAN1} alt="Fridge Service" title="Fridge Service" class="img-fluid" />
      </div>
      <div class="col-md-6">
        <h3 id="service-heading-fridge-service">Fridge Service</h3>
        <p id="service-description-fridge-service">We offer comprehensive fridge repair services that restore your appliance's cooling efficiency and extend its lifespan.</p>
      </div>
    </div>

   
    <div class="row service-item-tv-service">
      <div class="col-md-6">
        <img src={TVMAN1} alt="TV Service" title="TV Service" class="img-fluid" />
      </div>
      <div class="col-md-6">
        <h3 id="service-heading-tv-service">TV Service</h3>
        <p id="service-description-tv-service">Our TV service ensures your television works perfectly, with expert repair solutions for all brands and models.</p>
      </div>
    </div>

    
    <div class="row service-item-microwave-oven-service">
      <div class="col-md-6">
        <img src={MICROMAN1} alt="Microwave Oven Service" title="Microwave Oven Service" class="img-fluid" />
      </div>
      <div class="col-md-6">
        <h3 id="service-heading-microwave-oven-service">Microwave Oven Service</h3>
        <p id="service-description-microwave-oven-service">Get reliable microwave oven repairs that ensure efficient performance and durability. We handle all types of issues with precision.</p>
      </div>
    </div>

    
    <div class="row service-item-water-heater-service">
      <div class="col-md-6">
        <img src={WATMAN1} alt="Water Heater Service" title="Water Heater Service" class="img-fluid" />
      </div>
      <div class="col-md-6">
        <h3 id="service-heading-water-heater-service">Water Heater Service</h3>
        <p id="service-description-water-heater-service">Ensure consistent hot water with our expert water heater service, designed to repair and maintain your unit effectively.</p>
      </div>
    </div>

   
    <div class="row service-item-water-purifier-service">
      <div class="col-md-6">
        <img src={WATERP1} alt="Water Purifier Service" title="Water Purifier Service" class="img-fluid" />
      </div>
      <div class="col-md-6">
        <h3 id="service-heading-water-purifier-service">Water Purifier Service</h3>
        <p id="service-description-water-purifier-service">Our water purifier service helps maintain the efficiency and functionality of your purifier, ensuring clean and safe water at all times.</p>
      </div>
    </div>
  </div>
</section>

<section id="working-hours">
  <h2>Our Working Hours</h2>
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="working-day">
        <p id="sunday" className="day">Sunday: <span className="status" style={{ color: 'red' }}>Closed</span></p>



        </div>
        <div class="working-day">
          <p id="monday" class="day">Monday: <span class="status">9 AM - 9 PM</span></p>
        </div>
        <div class="working-day">
          <p id="tuesday" class="day">Tuesday: <span class="status">9 AM - 9 PM</span></p>
        </div>
        <div class="working-day">
          <p id="wednesday" class="day">Wednesday: <span class="status">9 AM - 9 PM</span></p>
        </div>
        <div class="working-day">
          <p id="thursday" class="day">Thursday: <span class="status">9 AM - 9 PM</span></p>
        </div>
        <div class="working-day">
          <p id="friday" class="day">Friday: <span class="status">9 AM - 9 PM</span></p>
        </div>
        <div class="working-day">
          <p id="saturday" class="day">Saturday: <span class="status">9 AM - 9 PM</span></p>
        </div>
      </div>
    </div>
  </div>
</section>








<section id="faq-section">
  <h2>Frequently Asked Questions (FAQ)</h2>

  <table class="table table-striped">
    <thead>
      <tr>
        <th>Service</th>
        <th>Question</th>
        <th>Answer</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>Washing Machine Service</td>
        <td>How often should I service my washing machine?</td>
        <td>It is recommended to service your washing machine at least once a year to maintain optimal performance and prevent unexpected breakdowns.</td>
      </tr>
      <tr>
        <td>AC Service</td>
        <td>How do I know when my AC needs servicing?</td>
        <td>If your AC is making strange noises, leaking water, or not cooling effectively, it is time for a service.</td>
      </tr>
      <tr>
        <td>Fridge Service</td>
        <td>What are the signs that my fridge needs a repair?</td>
        <td>Common signs include unusual noises, the fridge not cooling properly, or leaks of water inside the fridge.</td>
      </tr>
      <tr>
        <td>TV Service</td>
        <td>Why is my TV screen flickering or losing picture?</td>
        <td>Flickering or loss of picture can be due to a malfunctioning screen, loose connections, or an issue with the power supply.</td>
      </tr>
      <tr>
        <td>Microwave Oven Service</td>
        <td>What should I do if my microwave oven is not heating?</td>
        <td>If your microwave is not heating, it could be due to a malfunctioning magnetron or a problem with the power supply. We recommend getting it checked by a professional.</td>
      </tr>
      <tr>
        <td>Water Heater Service</td>
        <td>How can I tell if my water heater needs servicing?</td>
        <td>If you're experiencing inconsistent water temperature or no hot water at all, it's time to service your water heater.</td>
      </tr>
      <tr>
        <td>Water Purifier Service</td>
        <td>When should I replace the filter in my water purifier?</td>
        <td>Filters typically need to be replaced every 6-12 months, depending on usage and water quality. We offer filter replacement services.</td>
      </tr>
    </tbody>
  </table>
</section>



<div><Discliamber/></div>


      <div><Footer /></div>
    </>
  );
}
